import Overlay from "../../../Componentes/Overlay"
import Modal from "../../../Componentes/Utils/Modal"
import Formulario from "../../../Componentes/Utils/Formulario"
import FormComp from "../../../Componentes/FormComp"
import { useEffect, useState } from "react"
import useApi from "../../../hooks/useApi";

const ModalAddChecklistTipo = ({ fetchSuccess, item, fecharModal }) => {
    const api = useApi();


    useEffect(() => {

        if( !item ){
            return;
        }

        console.log( item );
        setTipoNome( item.nome || "" );
        setHasModelos( item.modelos || "" );

    }, [ item ])

    const [ loading, setLoading ] = useState( false );

    const [ tipoNome, setTipoNome ] = useState("");
    const [ hasModelos, setHasModelos ] = useState("");

    const HandleSubmit = async ( e ) => {

        e.preventDefault();

        setLoading( true )

        try{

            const formData = new FormData();

            formData.append('tipo', tipoNome);
            formData.append('hasModelos', hasModelos);

            let url = "";

            if( item ){
                formData.append('id', item.id );
                url = "/Painel/API/Checklist/EditTipo/"
            }else{
                url = "/Painel/API/Checklist/SaveNewTipo/"
            }

            const { data } = await api.post(url, formData, { withCredentials: true });
            console.log( data )
            
            if( fetchSuccess ){
                await fetchSuccess()
            }

            fecharModal();

        }catch( e ){

            console.log( e );

        }finally{

            setLoading( false );

        }

    }

    return(
        <>
            <Overlay state={true} >
                <Modal header={true} close={ fecharModal } >
                    <Formulario onSubmit={HandleSubmit} >
                        <FormComp
                            title="NOME DO TIPO"
                            type="text"
                            valor={ tipoNome }
                            changeFunc={(e) => setTipoNome( e.target.value.toUpperCase())}
                            required
                        />
                        <FormComp
                            title="POSSUI MODELOS ?"
                            type="select"
                            options={[
                                { label: "SIM", value: 1 },
                                { label: "NÃO", value: 0 }
                            ]}
                            obj
                            valor={ hasModelos }
                            changeFunc={( e ) => setHasModelos( e.target.value )}
                            required
                        />
                        <FormComp
                            type="submit"
                            valor={ loading ? "SALVANDO..." : "SALVAR" }
                            disabled={ loading }
                        />
                    </Formulario>
                </Modal>
            </Overlay>
        </>
    )
}

export default ModalAddChecklistTipo;